import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserBids } from '../../../actions/bidActions'
import { Table, Spinner, Alert, Col, Row } from 'react-bootstrap'
import { format } from 'date-fns'
import { Link, useNavigate } from 'react-router-dom'
import { FaExclamationTriangle } from 'react-icons/fa'
import { logout } from '../../../actions/userActions'
import { COLORS } from '../../../constants/colors'

const BidScreen = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userReducers: { user } } = useSelector(state => state)
    
    // Fix the destructuring to match the actual state structure
    const bidState = useSelector(state => state.bidReducers)
    const { bids, loading, error } = bidState || { bids: [], loading: false, error: null }
    
    // Define color constants to match with ProfileDetails.js
    const plum = COLORS.PLUM;
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const warmConcrete = COLORS.WARM_CONCRETE;

    useEffect(() => {
        if (user) {
            dispatch(getUserBids())
        }
    }, [dispatch, user])

    // Handle authentication error
    useEffect(() => {
        if (error && error.includes('Authentication credentials were not provided')) {
            // Log out the user and redirect to home page
            dispatch(logout())
            navigate('/')
        }
    }, [error, dispatch, navigate])

    if (!user) {
        return (
            <Alert variant="warning">
                Please <Link to="/login">log in</Link> to view your bids.
            </Alert>
        )
    }

    if (loading) {
        return (
            <div className="text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    // Show generic error but don't handle auth error here - it's handled in the useEffect
    if (error && !error.includes('Authentication credentials were not provided')) {
        return <Alert variant="danger">{error}</Alert>
    }

    return (
        <>
            <Row className='mx-3'>
                <Col md={4} className='h5'>
                    <span className='h5' style={{ color: plum }}>My Bids</span>
                </Col>
            </Row>
            <Row className='mx-3'>
                <Col className='d-flex justify-content-center mb-4'>
                    <hr className='divider'/>
                </Col>
            </Row>

            <Row className='mx-3'>
            {bids && bids.length > 0 ? (
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bids.map(bid => (
                            <tr key={bid._id}>
                                <td>
                                    <Link to={`/product/${bid.product._id}`} style={{ color: sageGreen, textDecoration: 'none' }}>
                                        {bid.product.name}
                                    </Link>
                                </td>
                                <td>R {bid.amount.toFixed(2)}</td>
                                <td>{format(new Date(bid.createdAt), 'PPpp')}</td>
                                <td>
                                    <span className={`badge bg-${bid.status === 'active' ? 'success' : 'secondary'}`}>
                                        {bid.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <Col className="mt-4">
                    <Alert 
                        className="text-center p-2" 
                        style={{ 
                            backgroundColor: warmConcrete, 
                            color: plum,
                            borderRadius: 4, 
                            border: `1px solid ${plum}`
                        }}
                    >
                        <div className="d-flex align-items-center justify-content-center">
                            <FaExclamationTriangle size={14} className="me-2" />
                            <strong>You haven't placed any bids yet.{' '}
                                <Link to="/categories/AUCTIONS-c-4" style={{ color: copper, textDecoration: 'none' }}>
                                    Browse our auctions
                                </Link>
                                {' '}to start bidding!
                            </strong>
                        </div>
                    </Alert>
                </Col>
            )}
            </Row>
        </>
    )
}

export default BidScreen